module.exports = __webpack_public_path__ + "img/mp.e98ae664.svg";